import React, { lazy, Suspense, useContext, useState } from "react";
import { useBotbPassDrawerContext } from "./botb-pass-modal-context";
import CloseModalIcon from "../../../../shared-components/icons/CloseModalIcon";
import { ErrorBoundary } from "react-error-boundary";
import CountdownTimer from "../../../../components/Countdown/countdown";
import { useCompetition } from "../../../../redux/features/categories/selectors";
import { HouseCompetitionData } from "../contextProvider";
import { useIsMobile } from "@/app/redux/features/device/selectors";
const SinglePurchase = lazy(() => import("./SinglePurchase"));
const SubscriptionPackages = lazy(() => import("./SubscriptionPackages"));
const PostalEntry = lazy(() => import("./PostalEntry"));

const TABS_DATA = [
  {
    title: "Postal",
    htmlTitle: <>Postal</>,
    desc: (
      <>
        No purchase
        <br className={"lg:hidden"} /> necessary
      </>
    ),
  },
  {
    title: "Single Purchase",
    htmlTitle: (
      <>
        Single
        <br className={"lg:hidden"} /> Purchase
      </>
    ),
  },
  {
    title: "Subscription",
    htmlTitle: <>Subscription</>,
    desc: (
      <>
        Auto entry in the monthly
        <br className={"lg:hidden"} /> Dream Home
      </>
    ),
  },
];

export const BotbPassDrawerContent = () => {
  const { closeModal, place } = useBotbPassDrawerContext();
  const houseCompetition = useCompetition({
    CompetitionTypePrefix: "HC",
  });
  const [activeTab, setActiveTab] = useState<"Postal" | "Single Purchase" | "Subscription">("Subscription");

  const isMobile = useIsMobile();

  // if (preSubscriptionDataLoading) {
  //   return (
  //     <Skeleton
  //       count={1}
  //       inline
  //       highlightColor="#fff"
  //       containerClassName="flex flex-col w-full h-[500px]"
  //       className="h-full"
  //     />
  //   );
  // }

  const { cashAlternativeText } = useContext(HouseCompetitionData);

  return (
    <>
      <div data-name="Overlay" className="fixed-theme inset-0 z-[9999] bg-black/80"></div>
      <div
        data-name="PopupContainer"
        className={"fixed inset-0 z-[99999] w-full min-h-full overflow-x-hidden overflow-y-auto font-jost"}>
        <div className={"w-full min-h-full flex items-center justify-center flex-col m-auto lg:p-6"}>
          <div
            className={
              "bg-[#F5F5F5] relative w-full lg:max-w-[1144px] lg:min-h-[707px] flex flex-col max-lg:grow lg:rounded-2xl"
            }>
            <button
              onClick={closeModal}
              className={"absolute flex items-center justify-center right-3 top-3 lg:right-2 lg:top-2 lg:size-10"}>
              <CloseModalIcon className={"size-6 text-gray-5"} />
            </button>

            <div className={"lg:rounded-2xl overflow-hidden"}>
              <div className={"flex flex-col gap-6 lg:gap-4 bg-white pt-8 px-4 lg:rounded-t-2xl"}>
                <div className={"flex flex-col items-center gap-3 lg:gap-4 self-stretch"}>
                  <div className={"flex justify-center items-center gap-2 bg-black px-4 py-1 lg:py-0.5 rounded-lg "}>
                    <CountdownTimer
                      EndDateTime={new Date(houseCompetition.EndDateTime)}
                      textClass={"text-white text-center text-xs leading-6 mr-1 lg:text-sm lg:leading-5"}
                      numericClass={"text-[#FF8200] font-bold text-center text-xs leading-6 lg:text-base"}
                      containerClass={"flex justify-center items-center gap-[2px] uppercase leading-none"}
                      format="d:h:m:s"
                    />
                  </div>

                  <div className={"flex flex-col items-center lg:gap-3 self-stretch"}>
                    <div
                      className={
                        "self-stretch text-[#28282B] text-center text-xl font-bold leading-[26px] lg:text-2xl lg:leading-[30px] uppercase"
                      }>
                      {houseCompetition.FeaturedPrizeModel}
                    </div>
                    <div
                      className={
                        "self-stretch text-[#4C4C52] text-center text-sm font-medium leading-5 lg:text-xl lg:font-normal lg:leading-[26px]"
                      }>
                      Or take {cashAlternativeText} in Cash
                    </div>
                  </div>
                </div>
                <div className="w-full flex max-lg:flex-col gap-8 lg:gap-12 items-center justify-center relative">
                  <div
                    className={`text-primary text-center font-jost text-xl font-medium leading-[26px] lg:text-base lg:leading-[22px]`}>
                    {isMobile ? "Choose below how to play:" : "Choose how to play our competitions:"}
                  </div>

                  <div className="flex xs:w-full lg:w-auto justify-center gap-[22px]">
                    {TABS_DATA.map((tab, index) => (
                      <div
                        key={`tab_${index}`}
                        className={`min-h-14 relative px-[5px] pt-[5px] lg:pt-[7px] text-center cursor-pointer items-center justify-start lg:justify-center flex flex-col border-b-1.5 lg:border-b-2 border-solid ${tab.title === activeTab ? "border-[#FF8200]" : "border-transparent"}`}
                        onClick={() => setActiveTab(tab.title as typeof activeTab)}>
                        {tab.title === "Subscription" && (
                          <div
                            className={
                              "inline-flex justify-center items-center gap-2 absolute top-[-13px] lg:-top-[21px] border bg-[#F33424] px-2 py-0.5 min-h-4 lg:min-h-[26px] rounded-full border-solid border-[#DD2F21] margin-x-auto"
                            }>
                            <span
                              className={
                                "text-white text-center font-jost text-[9px] font-semibold leading-none lg:text-sm"
                              }>
                              Save up to 75%*
                            </span>
                          </div>
                        )}
                        <div className={"flex flex-col justify-start items-center pb-[3px] lg:pb-[7px]"}>
                          <span
                            className={`text-sm font-medium leading-5 uppercase lg:text-base lg:leading-[22px] ${tab.title === activeTab ? "text-[#28282B]" : "text-[#696971]"}`}>
                            {tab.htmlTitle}
                          </span>
                          <span className="text-[#898994] text-center text-[11px] font-medium leading-[14px] -mt-[2px] whitespace-nowrap lg:text-sm lg:font-normal lg:leading-5">
                            {tab.desc}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <ErrorBoundary fallback={<span>Something went wrong.</span>}>
                <Suspense fallback={<div className={"min-h-[490px]"} />}>
                  {activeTab === "Postal" ? <PostalEntry /> : null}
                  {activeTab === "Single Purchase" ? <SinglePurchase /> : null}
                  {activeTab === "Subscription" ? <SubscriptionPackages place={place} /> : null}
                </Suspense>
              </ErrorBoundary>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
